import * as React from 'react';
import { NoSsr } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { GeoLocationButton } from '../../../components/packages/GeoLocation';
import { useGeoLocationFilter } from './utils';
import { GeoLocationModalContainerDesktop, GeoLocationModalContainerMobile } from './components';
import { withUnmountClosed } from '../../../hocs/unmountClosed';

export function GeoLocationContainer() {
  const { selectedRegion, handleClose, handleOpen, handleSelectRegion, isModalOpen } = useGeoLocationFilter();
  const isDesktop = useDeviceType() === 'desktop';
  const GeoLocationModalContainer = withUnmountClosed(
    isDesktop ? GeoLocationModalContainerDesktop : GeoLocationModalContainerMobile,
  );

  return (
    <div>
      <GeoLocationButton onClick={handleOpen} text={selectedRegion.displayName} />
      <NoSsr>
        <GeoLocationModalContainer
          title="Выберите регион"
          isOpen={isModalOpen}
          onClose={handleClose}
          onSelectRegion={handleSelectRegion}
        />
      </NoSsr>
    </div>
  );
}
